import { useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import BlockShell from "./BlockShell";
import Lightbox from "../Lightbox";
import { absUrl } from "./media";

const RichTextBlock = ({ block }) => {
  const cfg = block.config || {};
  const [zoom, setZoom] = useState(null);
  const accent = cfg.accent || "#2E5C55";
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-8" data-testid="fest-richtext">
      <BlockShell block={block} accent={accent}>
        <div className="prose max-w-3xl text-[#3a3a3a] leading-relaxed whitespace-pre-line text-base md:text-lg">
          {cfg.body}
        </div>
        {cfg.show_map && cfg.map_center && (
          <div className="rounded-xl overflow-hidden border border-[#E2E0DC] mt-6" style={{ height: 320 }}>
            <MapContainer center={cfg.map_center} zoom={cfg.map_zoom || 15} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker position={cfg.map_center}>
                <Popup>{block.title}</Popup>
              </Marker>
            </MapContainer>
          </div>
        )}
        {cfg.show_gallery && (cfg.images || []).length > 0 && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-6">
            {(cfg.images || []).map((img) => (
              <button type="button" key={img} onClick={() => setZoom(absUrl(img))} className="cursor-zoom-in" aria-label="Enlarge photo">
                <img src={absUrl(img)} alt="" className="w-full aspect-square object-cover rounded-md border" loading="lazy" />
              </button>
            ))}
          </div>
        )}
        <Lightbox src={zoom} onClose={() => setZoom(null)} />
      </BlockShell>
    </section>
  );
};

export default RichTextBlock;
